module.exports = __webpack_public_path__ + "static/media/drupal.a9076afc.svg";